import { Button } from '@/components/ui/button'
import { Check } from 'lucide-react'

interface FormSubmitButtonProps {
  isSubmitting: boolean
}

export function FormSubmitButton({ isSubmitting }: FormSubmitButtonProps) {
  return (
    <div className="flex justify-center pt-6">
      <Button
        type="submit"
        disabled={isSubmitting}
        className="bg-gray-800 hover:bg-gray-700 text-white px-8 py-3"
      >
        <Check className="w-4 h-4 mr-2" />
        {isSubmitting ? 'Adicionando...' : 'Adicionar Conteúdo'}
      </Button>
    </div>
  )
}
